import React from 'react';
import { Navigate } from 'react-router-dom';

const isAuthenticated = () => {
  return (
    !!localStorage.getItem('token') || // legacy login
    !!localStorage.getItem('admin') || // admin login
    !!localStorage.getItem('superAdmin') || // super admin
    !!localStorage.getItem('agent') // agent login
  );
};

const ProtectedRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
